import { Skeleton } from 'antd';
import { cardStyle } from '../../components/vinExtraction/vinExtractionStyles';

const SettingsSkeleton = () => (
    <div style={cardStyle}>
        <Skeleton active title={false} paragraph={{ rows: 1 }} />
    </div>
);

export default SettingsSkeleton;
